<div class="date-picker-overlay">
    <div class="date-picker-modal">
      <div class="modal-header">
        <span>Tanggal Pengaktifan</span>
        <button class="close-btn" (click)="close()"><img src="assets/icons/close.svg" alt=""></button>
      </div>
  
      <div class="month-navigator">
        <button (click)="previousMonth()"><img src="assets/icons/chevron-left-blue.svg" alt=""></button>
        <span>{{ currentMonth }} {{ currentYear }}</span>
        <button (click)="nextMonth()"><img src="assets/icons/chevron-right-blue.svg" alt=""></button>
      </div>
  
      <div class="calendar">
        <div class="weekdays">
            @for (day of weekDays; track $index) {
                <div>{{ day }}</div>
            }
        </div>
  
        <div class="days">
          @for (day of calendarDays; track $index) {
          <button type="button" class="day" [class.other-month]="day.otherMonth" [class.selected]="isSelected(day.date)"
            (click)="selectDate(day.date)">
            {{ day.date.getDate() }}
          </button>
          }
        </div>
      </div>
  
      <button [disabled]="!selectedDate()" [class.active]="selectedDate()" class="select-btn" (click)="confirmSelection()">Pilih</button>
    </div>
  </div>